// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"29":"EntryInfo","594":"about"}[chunkId] + "." + {"29":"8ae89c3e","594":"0b99676e"}[chunkId] + ".js";
};